import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, HostBinding, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {
  ProjectsUsersTeamsSelectionComponent,
  UsersTeamsSelectionData,
} from '../../users-teams-selection/projects-users-teams-selection.component';

@Component({
  selector: 'projects-users-teams-selection-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, ProjectsUsersTeamsSelectionComponent],
  templateUrl: './projects-users-teams-selection-dialog.component.html',
  styleUrl: './projects-users-teams-selection-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsUsersTeamsSelectionDialogComponent {
  @HostBinding('class.oph-scroll-bar') readonly ophScrollBar = true;

  private readonly dialogRef = inject(MatDialogRef<ProjectsUsersTeamsSelectionDialogComponent>);
  readonly data = inject<UsersTeamsSelectionData>(MAT_DIALOG_DATA);

  onClose(): void {
    this.dialogRef.close();
  }
}
